import { useContext } from 'react';
import EditorContext from '@/context/editor.context';

export const useEditor = () => useContext(EditorContext);
